var cilVolumeLow = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M320,168v32a56,56,0,0,1,0,112v32a88,88,0,0,0,0-176Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M145.373,120H16V392H145.373l104,104H288V16H249.373ZM128,360H48V152h80Zm128,97.373-96-96V150.627l96-96Z' class='ci-primary'/>"];

export { cilVolumeLow };

